import script from "./AppBarNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBarNotification.vue?vue&type=script&setup=true&lang=js"

import "./AppBarNotification.vue?vue&type=style&index=0&id=23b67cf2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b67cf2"]])

export default __exports__